import BackIcon from '@mui/icons-material/ArrowBack'
import { Button, Paper, Stack } from '@mui/material'
import { useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useScreenSize } from '../../hooks/useScreenSize'
import { ProfileCard } from './ProfileCard'

export enum PROFILE_SECTIONS {
    REWARDS = 'rewards',
    STATS = 'stats',
    ACCOUNT = 'account',
    SETTINGS = 'settings',
}

export const ProfileNavigation = () => {
    const { isMobile } = useScreenSize()
    const { section } = useParams<{ section: PROFILE_SECTIONS }>()

    const navigate = useNavigate()

    useEffect(() => {
        if (!section) {
            navigate(`/profile-v2/${PROFILE_SECTIONS.REWARDS}`, { replace: true })
        }
    }, [])

    return (
        <Stack direction="column" gap={1} sx={{ width: { xs: '100%', md: '50%' } }} justifyContent="space-between">
            <Paper variant="outlined">
                <Stack
                    direction="column"
                    alignItems="center"
                    gap={1}
                    sx={{
                        display: 'grid',
                        gridTemplateAreas: {
                            xs: `
                                "profile profile"
                                "rewards stats"
                                "account settings"
                            `,
                            md: `
                            "profile"
                            "rewards"
                            "stats"
                            "account"
                            "settings"
                            `,
                        },
                    }}
                >
                    <ProfileCard />
                    {Object.values(PROFILE_SECTIONS).map((item) => (
                        <Link replace={true} to={`/profile-v2/${item}`} key={item} style={{ width: '100%' }}>
                            <Button
                                sx={{ gridArea: item }}
                                fullWidth
                                key={item}
                                size={isMobile ? 'small' : 'large'}
                                selected={item === section}
                            >
                                {item}
                            </Button>
                        </Link>
                    ))}
                </Stack>
            </Paper>

            <Button
                size={isMobile ? 'small' : 'large'}
                startIcon={<BackIcon />}
                variant="outlined"
                color="primary"
                onClick={() => navigate(-1)}
            >
                Return
            </Button>
        </Stack>
    )
}
